import { useContext } from "react";
import { doc, updateDoc, serverTimestamp } from "firebase/firestore";
import { FirebaseContext } from "../../providers/FirebaseProvider/FirebaseProvider";

// Soft delete a group: stamp `deletedAt` instead of removing the document, so
// nothing is physically deleted. The planned lessons / bookings / group-logs
// live in separate collections and keep referencing the group by id — they are
// intentionally left untouched.
function useDeleteGroup() {
  const { firestoreDb } = useContext(FirebaseContext);

  const deleteGroup = async (groupId) => {
    const groupRef = doc(firestoreDb, "groups", groupId);
    await updateDoc(groupRef, { deletedAt: serverTimestamp() });
  };

  return deleteGroup;
}

export default useDeleteGroup;
